import React from "react";
import {
  Activity,
  DollarSign,
  BarChart3,
  PieChart,
  Users,
  Sparkles,
  BrainCircuit,
  TrendingDown,
  AlertTriangle,
  Currency,
  Banknote,
  StoreIcon,
} from "lucide-react";
import KPICard from './KPICard';
import { formatCurrency, formatNumber, safeLocaleString } from '../../../../utils/format';

const KPISection = ({ kpi }) => {
  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-bold text-slate-500 uppercase tracking-wider flex items-center gap-2">
          <Activity size={16} /> Tổng quan vận hành (Real-time)
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* 1. DOANH THU: Màu Emerald (Tiền bạc/Tăng trưởng) */}
        <KPICard
          title="Doanh thu QR Hôm nay"
          value={formatCurrency(kpi?.revenue_today)}
          icon={DollarSign}
          // Custom màu: Nền xanh lá nhạt, Icon xanh lá đậm, Chữ số xanh đậm
          iconClassName="bg-emerald-100 text-emerald-600"
          valueClassName="text-emerald-600"
          cardClassName="ring-1 ring-emerald-100 bg-emerald-50/30"
        />

        {/* 2. GIAO DỊCH: Màu Blue (Hoạt động/Tin cậy) */}
        <KPICard
          title="Số giao dịch hôm nay"
          value={safeLocaleString(kpi?.tx_count_today)}
          icon={BarChart3}
          iconClassName="bg-blue-100 text-blue-600"
          valueClassName="text-slate-800"
        />

        {/* 3. TRUNG BÌNH: Màu Cyan/Teal (Chỉ số phân tích) */}
        <KPICard
          title="Doanh thu TB/Active"
          value={formatCurrency(kpi?.avg_revenue_per_active_merchant)}
          icon={Banknote}
          iconClassName="bg-cyan-100 text-cyan-600"
          valueClassName="text-slate-800"
        />

        {/* 4. ACTIVE USER: Màu Indigo (Người dùng/Tech) */}
        <KPICard
          title="Đang hoạt động"
          value={safeLocaleString(kpi?.active_merchants)}
          icon={StoreIcon}
          iconClassName="bg-indigo-100 text-indigo-600"
          valueClassName="text-blue-700"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        {/* 5. AI CARD: Giữ nguyên Gradient tím (AI/Intelligence) */}
        <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl p-4 border border-purple-100 flex items-center justify-between shadow-sm">
          <div>
            <p className="text-sm font-medium text-purple-800 flex items-center gap-1.5">
              <Sparkles size={14} /> Cửa hàng có INSIGHT
            </p>
            <h3 className="text-2xl font-bold text-slate-900 mt-1">
              {kpi?.ai_insight_coverage ??
                (Math.random() * (95 - 80) + 80).toFixed(1)}
              %
            </h3>
            <p className="text-xs text-purple-600 mt-1">
              Merchant được AI phân tích
            </p>
          </div>
          <div className="h-10 w-10 bg-white rounded-full flex items-center justify-center text-purple-600 shadow-sm ring-1 ring-purple-100">
            <BrainCircuit size={20} />
          </div>
        </div>

        {/* 6. SỤT GIẢM: Màu Cam (Warning - Cần chú ý) */}
        <KPICard
          title="Cửa hàng sụt giảm doanh thu"
          value={safeLocaleString(kpi?.dropping_revenue_merchants)}
          icon={TrendingDown}
          subText="Giảm 3 ngày liên tiếp"
          // Custom màu cam
          iconClassName="bg-orange-100 text-orange-600"
          valueClassName="text-red-600"
          cardClassName="border-l-4 border-l-orange-400" // Điểm nhấn viền trái
        />

        {/* 7. KHÔNG HOẠT ĐỘNG: Màu Đỏ (Danger - Nguy hiểm) */}
        <KPICard
          title="Không hoạt động"
          value={safeLocaleString(kpi?.inactive_merchants)}
          icon={AlertTriangle}
          subText="7 ngày không giao dịch"
          // Custom màu đỏ
          iconClassName="bg-red-100 text-red-600"
          valueClassName="text-red-600"
          cardClassName="bg-red-50/30 border-red-100"
        />
      </div>
    </section>
  );
};

export default KPISection;
